<style lang="scss">
@import './index.scss';
</style>
<template>
  <div class="add-usergroup">
    <h1>
      <a @click="isCertainLeave">{{ $t('nav.user.group') }} ></a>
      <span v-if="!userGroupId">{{ $t('addUserGroup.add') }}</span>
      <span v-else>{{ $t('addUserGroup.edit') }}</span>
    </h1>
    <div class="add-usergroup-box">
      <div class="add-usergroup-content">
        <!-- 用户群名称 -->
        <div class="userName">
          <h3>{{ $t('addUserGroup.groupName') }}</h3>
          <Input class="group-input" @on-blur="nameBlur" :maxlength="20" v-model="groupName" :placeholder="$t('addUserGroup.placeholder')" icon="md-close" @on-click="clearUserName"></Input>
          <span v-if="nameIsNull">{{ $t('addUserGroup.placeholder') }}</span>
        </div>
        <!-- 用户范围 -->
        <div class="userRange">
          <h3>{{ $t('addUserGroup.groupRange') }}</h3>
          <Select @on-change="selectUserType" style="width:200px" :value="returnTypeValue">
            <Option v-for="item in $t('addUserGroup.userRange')" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>

          <Date-picker
            :value="user.timeflag.$between"
            :options="datePickerOptions"
            @on-change="rangeDate"
            :clearable = "false"
            format="yyyy-MM-dd"
            type="daterange"
            placement="bottom-end"
            style="width: 200px;display:inline-block;"
            split-panels
          >
          </Date-picker>
        </div>
        <!-- 用户属性 -->
        <user-attribute
          :return-data="attributeData"
          :attribute-exp="attributeExpr">
        </user-attribute>
        <div class="splitter-box">
          <h3 class="splitter">AND</h3>
        </div>
        <!-- 用户行为 -->
        <user-behavior
          :raw-data="rawData"
          :module-items="moduleItems"
          :behavior-expr="behaviorExpr"
          :item-list="itemList"
          :itemBackup="itemBackup"
        >
        </user-behavior>

        <div class="prompt">
          <span v-if="nameConflict">
            <Icon color="#ed3f14" type="md-close-circle"></Icon>
            {{ $t('addUserGroup.nameConflict') }}
          </span>
          <span v-if="exprConflict">
            <Icon color="#ed3f14" type="md-close-circle"></Icon>
            {{ $t('addUserGroup.exprConflict') }}
          </span>
        </div>
        <div class="save-cancel">
          <Button type="primary" :loading="addLoading" @click="submit" style="width:200px;height:35px;">{{ $t('common.save') }}</Button>
          <Button v-if="!userGroupId" type="text" @click="emptyCondition" >{{ $t('filter.clear') }}</Button>
          <Button v-else type="text" @click="recoveryCondition" >{{ $t('addUserGroup.recover') }}</Button>
        </div>
      </div>
    </div>
    <!-- 通用询问窗口，当前页处于设置页面，跳转其他页面时的提示 -->
      <Modal
        v-model="discardChangeShow"
        :mask-closable="false"
        @on-ok="discardChange"
      >
        {{ $t('common.noSave') }} <br/>
        {{ $t('common.isLeave') }}
      </Modal>
  </div>
</template>
<script>
import bus from '../../libs/bus';
import busModual from '../../libs/busModual';
import util from '../../libs/util';
import filterData from '../../filters/change-usergroup-data';
import userAttribute from '../../components/add-usergroup/user-attribute';
import userBehavior from '../../components/add-usergroup/user-behavior';

export default {
  data() {
    return {
      // 模拟属性数据
      dataInfo: {},
      // 模拟行为数据
      exprList: {},
      // 用户群名称是否为空 boolean
      nameIsNull: false,
      // 用户类型
      userType: busModual.userRangeType,
      // 用户分群名称
      groupName: '',
      // 用户范围->日期选择器
      datePickerOptions: {
        disabledDate(date) {
          // 控制时间段，当前应用接入 analytics之前的时间段禁选
          const regTime = bus.userReg.replace(/-/g, '/');
          return date && (date.valueOf() > Date.now()
          || date.valueOf() < Date.parse(regTime));
        },
      },
      // 用户范围->日期选择器绑定的时间范围
      user: {
        timeflag: {
          $between: [
            bus.selectedDate[0],
            bus.selectedDate[1],
          ],
        },
      },
      // 用户群名称冲突提示
      nameConflict: false,
      // 用户群条件冲突提示
      exprConflict: false,
      addLoading: false,
      // 请求后未做修改的用户群名称
      oldName: '',
      // 请求后处理的表达式
      globalExpr: {},
      // item group 数据备份
      // itemBackup: {},
      discardChangeShow: false,
    };
  },
  components: {
    userAttribute,
    userBehavior,
  },
  filters: {

  },
  computed: {
    // 分群列表传递相关参数,有则为编辑，无则为新建
    userGroupId() {
      // eslint-disable-next-line
      return bus.setUserGroupId || sessionStorage.getItem('_app_setUserGroupId')|| bus.sessionStorage._app_setUserGroupId;
    },
    // 用户范围->用户类型
    returnTypeValue() {
      return this.userType === 'newuser' ?
      this.$t('addUserGroup.userRange[0].value') : this.$t('addUserGroup.userRange[1].value');
    },
    attributeExpr() {
      return {
        relation: '$and',
        expr: [],
      };
    },
    // 提取出attribute组件需要的数据
    attributeData() {
      const list = this.dataInfo;
      if (!Object.keys(list).length) return {};
      const attributeList = ['mobile_info', 'os_info', 'isp_info', 'partner_info', 'user_region', 'user_country', 'user_province'];
      const tmp = {};
      attributeList.forEach((v) => {
        const item = list[v];
        if (item) {
          const mapName = v === 'user_region' || v === 'user_country' || v === 'user_province' ? 'user_region' : v;
          tmp[mapName] = item.expr[0][v];
          tmp.relation = item.relation;
        }
      });
      return tmp;
    },
    // 展示的模块数组
    moduleItems() {
      const exprList = this.exprList;
      // 目前不支持 useTimes使用时长 startTimes启动次数
      const items = ['lostDays', 'customevent', 'page_view', 'launch_info'];
      const array = Object.keys(exprList).map((x) => {
        let b = x;
        if (b !== 'page_view' && b !== 'launch_info') b = b.split('_')[0];
        return b;
      });
      const module = items.filter(x => array.indexOf(x) > -1);
      return module;
    },
    // 除事件，页面，活跃外的用户行为数据 rawData
    rawData() {
      const list = this.moduleItems;
      const exprList = this.exprList;
      const obj = {};
      list.forEach((x) => {
        if (['customevent', 'page_view', 'launch_info'].indexOf(x) === -1 && exprList[x]) {
          obj[x] = exprList[x].expr[0];
        }
      });
      return obj;
    },
    // 用户行为数据
    behaviorExpr() {
      const exprList = this.exprList;
      const expr = [];
      let relation = '$and';
      this.moduleItems.forEach((x) => {
        if (['customevent', 'page_view', 'launch_info'].indexOf(x) === -1 && exprList[x]) {
          relation = exprList[x].relation;
          expr.push(exprList[x].expr[0]);
        }
        if (['customevent', 'page_view', 'launch_info'].indexOf(x) > -1 && exprList[x]) {
          relation = exprList[x].parentRel;
        }
      });
      return {
        relation,
        expr,
        detail: {}, // 表达式文案
      };
    },
    itemBackup() {
      const exprList = this.exprList;
      // let relation = '';
      // let exprArr = [];
      const allDetail = exprList.detail ? JSON.parse(exprList.detail) : {};
      const itemArr = ['customevent', 'page_view', 'launch_info'];
      const tempObj = {};

      itemArr.forEach((type) => {
        const detail = allDetail[type] || {};
        let relation = '';
        let exprArr = [];

        // 获取表达式列表
        const itemExprList = exprList[type];

        if (itemExprList) {
          relation = itemExprList.relation || '$and';
          exprArr = exprArr.concat(itemExprList.expr);
        }

        tempObj[type] = {
          relation, // $and, $or
          expr: exprArr, // 表达式列表
          detail,  // 表达式文案
          errorStatus: false, // item重复标志
        };
      });
      return tempObj;
    },
    itemList() {
      const exprList = this.exprList;
      const allDetail = exprList.detail ? JSON.parse(exprList.detail) : {};
      const itemArr = ['customevent', 'page_view', 'launch_info'];
      const tempObj = {};

      itemArr.forEach((type) => {
        let relation = '';
        let exprArr = [];
        const detail = {};
        detail[type] = allDetail[type] || [];

        // 获取表达式列表
        const itemExprList = exprList[type];
        if (itemExprList) {
          relation = itemExprList.relation || '$and';
          exprArr = exprArr.concat(itemExprList.expr);
        }

        tempObj[type] = {
          relation, // $and, $or
          expr: exprArr, // 表达式列表
          detail,  // 表达式文案
          errorStatus: false, // item重复标志
        };
      });
      return tempObj;
    },
  },
  mounted() {
    bus.$on('on-app-change', this.goUserGroup);
    bus.$on('on-platform-change', this.goUserGroup);
    // 初始化bus.userRangeDate
    busModual.userRangeDate = this.user.timeflag.$between;

    // 判断是否为编辑用户分群
    if (this.userGroupId) this.getGroupData();

    // 模拟数据解析
    if (!Object.keys(this.dataInfo).length) return;
    this.userType = this.dataInfo.newuser ? 'newuser' : 'launchuser';
    busModual.userRangeType = this.dataInfo.newuser ? 'newuser' : 'launchuser';
    this.user = this.dataInfo[this.userType].expr[0][this.userType];
  },
  beforeDestroy() {
    bus.$off('on-app-change', this.goUserGroup);
    bus.$off('on-platform-change', this.goUserGroup);
  },
  methods: {
    // 点击title
    isCertainLeave() {
      this.discardChangeShow = true;
    },
    // 询问窗口 确定按钮
    discardChange() {
      this.goUserGroup();
    },
    // name输入框失焦事件
    nameBlur() {
      this.nameIsNull = this.groupName.length < 1;
    },
    // 清空用户分群名称
    clearUserName() {
      this.groupName = '';
    },
    // 获取用户分群信息
    getGroupData() {
      util.ajax.get(`/cohort/api/v1/cohort/get/${bus.productid}/${this.userGroupId}`)
        .then((res) => {
          const result = filterData(res);
          this.globalExpr = JSON.stringify(result);
          this.oldName = res.name;
          this.assignment(res.name, result);
        });
    },
    /**
     * 赋值给各组件
     * @param name {String} 初始name名
     * @param result {Array} 处理后的表达式对象
     **/
    assignment(name, result) {
      this.userType = result.newuser ? 'newuser' : 'launchuser';
      busModual.userRangeType = result.newuser ? 'newuser' : 'launchuser';
      this.groupName = name;
      this.user = result[this.userType].expr[0][this.userType];
      this.dataInfo = result;
      this.exprList = result;
    },
    goUserGroup() {
      this.$router.push(`/analytics/user/group/${(bus.productInfo.productid || this.$route.params.productid)}`);
    },
    // 保存
    submit() {
      const itemList = this.itemList;
      if (this.groupName.length < 1) this.nameIsNull = true;
      // 行为所选事件、页面、活跃是否存在重复条件
      const hasError = itemList.customevent.errorStatus
      || itemList.page_view.errorStatus || itemList.launch_info.errorStatus;
      if (this.groupName.length < 1 || hasError) return;
      const params = this.mergeData();

      // 若存在userGroupId则为编辑，否则为新建
      if (this.userGroupId) {
        util.ajax.put(`/cohort/api/v1/cohort/update/USER/${bus.productid}/${this.userGroupId}`, params).then((res) => {
          // 用户群名称冲突
          if (res.conflict && res.conflict === 'name') {
            this.nameConflict = true;
          // 用户群条件冲突
          } else if (res.conflict && res.conflict === 'expression') {
            this.exprConflict = true;
          } else {
            this.$Message.success({
              content: this.$t('addUserGroup.editSuccess'),
              duration: 3,
            });
            this.goUserGroup();
          }
        });
      } else {
        util.ajax.post(`/cohort/api/v1/cohort/add/USER/${bus.productid}`, params).then((res) => {
          // 用户群名称冲突
          if (res.conflict && res.conflict === 'name') {
            this.nameConflict = true;
          // 用户群条件冲突
          } else if (res.conflict && res.conflict === 'expression') {
            this.exprConflict = true;
          } else {
            this.$Message.success({
              content: this.$t('addUserGroup.addSuccess'),
              duration: 3,
            });
            this.goUserGroup();
          }
        }).catch((err) => {
          // eslint-disable-next-line
          console.log(err.response);
        });
      }
    },
    // 新建置空
    emptyCondition() {
      this.groupName = '';
      this.exprList = {};
      bus.$emit('on-usergroup-reset');
    },
    // 编辑时恢复最初筛选状态
    recoveryCondition() {
      this.assignment(this.oldName, JSON.parse(this.globalExpr));
      bus.$emit('on-usergroup-recover');
    },
    // 合并 用户属性、行为表达式
    mergeData() {
      const itemList = this.itemList;
      const attribute = this.attributeExpr;
      const behave = this.behaviorExpr;
      const events = itemList.customevent;
      const pages = itemList.page_view;
      const launchinfo = itemList.launch_info;
      // 行为是$and 或者 $or
      const behaveRelation = behave.relation;

      const obj = {
        name: this.groupName,
        expr: {
          $and: [],
          $or: [],
        },
        detail: {},
      };

      // 用户范围detail
      obj.detail[this.userType] = this.user.timeflag.$between;

      obj.expr[this.userType] = this.user;
      // 整合属性、流失情况
      function merge(item) {
        if (item.relation === '$and') {
          obj.expr.$and = obj.expr.$and.concat(item.expr);
        } else {
          obj.expr.$or = obj.expr.$or.concat(item.expr);
        }
        // 目标表达式存在detail则整合
        if (item.detail && Object.keys(item.detail).length > 0) {
          Object.keys(item.detail).forEach((v) => {
            obj.detail[v] = item.detail[v];
          });
        }
      }

      // 整合行为
      function mergeBehavior(item) {
        const tmp = {};
        const relation = item.relation;
        tmp[relation] = item.expr;
        obj.expr[behaveRelation].push(tmp);

        // 目标表达式存在detail则整合
        if (item.detail && Object.keys(item.detail).length > 0) {
          Object.keys(item.detail).forEach((v) => {
            obj.detail[v] = item.detail[v];
          });
        }
      }

      if (attribute.expr && attribute.expr.length > 0) merge(attribute);
      if (behave.expr && behave.expr.length > 0) merge(behave);
      if (events.expr && events.expr.length > 0) mergeBehavior(events);
      if (pages.expr && pages.expr.length > 0) mergeBehavior(pages);
      if (launchinfo.expr && launchinfo.expr.length > 0) mergeBehavior(launchinfo);
      obj.detail = JSON.stringify(obj.detail);
      return obj;
    },
    // 选择用户类型
    selectUserType(value) {
      this.userType = value;
      busModual.userRangeType = value;

      this.verifyDateTip();
      bus.$emit('on-usergroup-type-change');
    },
    // 固定日期选择器
    rangeDate(date) {
      this.user.timeflag.$between = date;
      busModual.userRangeDate = date;

      this.verifyDateTip();
    },
    // 验证日期的提示
    verifyDateTip() {
      if (this.userType === 'newuser') {
        // 取消全局提示
        this.$Message.destroy();
        this.$Message.warning({
          content: this.$t('addUserGroup.verifyDate'),
          duration: 10,
        });
      }
    },
  },
  watch: {
    // 提示5s消失
    nameConflict(newValue, oldVlaue) {
      if (newValue && !oldVlaue) {
        setTimeout(() => {
          this.nameConflict = false;
        }, 5000);
      }
    },
    exprConflict(newValue, oldVlaue) {
      if (newValue && !oldVlaue) {
        setTimeout(() => {
          this.exprConflict = false;
        }, 5000);
      }
    },
  },
};
</script>
